import { createFileRoute } from '@tanstack/react-router';

import { requireAdmin } from '@/components/admin/require-admin.ts';
import { AnnouncementListPage } from '@/views/admin/announcement-list-page.tsx';

export const Route = createFileRoute('/admin/announcements')({
  beforeLoad: requireAdmin,
  component: AnnouncementListPage,
});
